export default "__VITE_ASSET__Rb36aMvl__"